/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import TooltipComponet from "../../../../../components/toolTip/tooltip";
import { useForm } from "react-hook-form";
import { BiPlusMedical } from "react-icons/bi";
import { Escalamiento } from "./escalamiento/escalamiento";
import Contacto from "./escalamiento/contacto";

function EditSlas({ id, close }) {
  const [services, setServices] = useState([]);
  const [sla, setSla] = useState({});
  const [esca, setEsca] = useState(0);
  const [contact, setContact] = useState(0);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    notification_service_id: "",
    fail_notification_body: "",
    success_notification_body: "",
    range_scale: { 0: "" },
    tries: { 0: "" },
    full_nameScale: { 0: [""] },
    mailScale: { 0: [""] },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const getSla = async (id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_slas/find/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setSla(res.data.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getSla(id);
  }, [id]);

  const updateFormData = () => {
    if (sla && sla.sla) {
      const updatedFormData = {
        name: sla.sla.name,
        description: sla.sla.description,
        notification_service_id: sla.sla.notification_service_id.toString(),
        fail_notification_body: sla.sla.fail_notification_body,
        success_notification_body: sla.sla.success_notification_body,
        range_scale: {},
        tries: {},
        full_nameScale: {},
        mailScale: {},
      };

      if (sla.levels && sla.levels.length > 0) {
        sla.levels.forEach((level, index) => {
          updatedFormData.range_scale[index.toString()] = level.range;
          updatedFormData.tries[index.toString()] = level.tries;
          updatedFormData.full_nameScale[index.toString()] = [];
          updatedFormData.mailScale[index.toString()] = [];

          level.emails.forEach((email, emailIndex) => {
            updatedFormData.full_nameScale[index.toString()][emailIndex] =
              email.name;
            updatedFormData.mailScale[index.toString()][emailIndex] =
              email.mail;
          });
        });
      }

      setFormData(updatedFormData);
      setLoading(false);
    }
  };

  useEffect(() => {
    updateFormData();
  }, [sla]);

  useEffect(() => {
    let keys = Object.keys(formData.full_nameScale);
    if (keys.length > 0) {
      setEsca(keys.length - 1);
      if (formData.full_nameScale[0]) {
        setContact(formData.full_nameScale[0].length - 1);
      }
    } else {
      setLoading(false);
    }
  }, [formData]);

  const getDataServices = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setServices(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getDataServices();
  }, []);

  const handleFormSubmit = async (data) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_slas/update/${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        Swal.fire(
          "Actualizado!",
          "El registro ha sido actualizado.",
          "success"
        );
        close();
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleRangeScale = (index, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      range_scale: {
        ...prevFormData.range_scale,
        [index]: value,
      },
    }));
  };

  const handleTries = (index, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      tries: {
        ...prevFormData.tries,
        [index]: value,
      },
    }));
  };

  const handleFullNameScaleChange = (propertyIndex, arrayIndex, value) => {
    setFormData((prevFormData) => {
      const updatedFullNameScale = { ...prevFormData.full_nameScale };

      if (!updatedFullNameScale[propertyIndex]) {
        updatedFullNameScale[propertyIndex] = [];
      }

      updatedFullNameScale[propertyIndex][arrayIndex] = value;

      return {
        ...prevFormData,
        full_nameScale: updatedFullNameScale,
      };
    });
  };

  const handleMailScale = (propertyIndex, arrayIndex, value) => {
    setFormData((prevFormData) => {
      const updatedMailScale = { ...prevFormData.mailScale };

      if (!updatedMailScale[propertyIndex]) {
        updatedMailScale[propertyIndex] = [];
      }

      updatedMailScale[propertyIndex][arrayIndex] = value;

      return {
        ...prevFormData,
        mailScale: updatedMailScale,
      };
    });
  };

  const addMed = () => {
    setFormData((prevFormData) => {
      const newIndex = Object.keys(prevFormData.range_scale).length;

      return {
        ...prevFormData,
        range_scale: {
          ...prevFormData.range_scale,
          [newIndex]: "",
        },
        tries: {
          ...prevFormData.tries,
          [newIndex]: "",
        },
        full_nameScale: {
          ...prevFormData.full_nameScale,
          [newIndex]: [""],
        },
        mailScale: {
          ...prevFormData.mailScale,
          [newIndex]: [""],
        },
      };
    });
  };

  const addContact = () => {
    setContact((prevContact) => prevContact + 1);
  };

  const removeMed = (index) => {
    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };

      const restructureObject = (obj) => {
        const newObj = {};
        let newKey = 0;
        for (let key in obj) {
          if (parseInt(key) !== index) {
            newObj[newKey] = obj[key];
            newKey++;
          }
        }
        return newObj;
      };

      if (
        newFormData.full_nameScale &&
        typeof newFormData.full_nameScale === "object"
      ) {
        newFormData.full_nameScale = restructureObject(
          newFormData.full_nameScale
        );
      }

      if (newFormData.mailScale && typeof newFormData.mailScale === "object") {
        newFormData.mailScale = restructureObject(newFormData.mailScale);
      }

      if (
        newFormData.range_scale &&
        typeof newFormData.range_scale === "object"
      ) {
        newFormData.range_scale = restructureObject(newFormData.range_scale);
      }

      if (newFormData.tries && typeof newFormData.tries === "object") {
        newFormData.tries = restructureObject(newFormData.tries);
      }

      return newFormData;
    });
    setEsca((prev) => (prev > 0 ? prev - 1 : 0));
  };

  const removeContact = (index, indexArray) => {
    const restructureArray = (arr) => {
      return arr.filter((_, idx) => idx !== indexArray);
    };

    setFormData((prevFormData) => {
      const newFormData = { ...prevFormData };

      console.log("Removing contact at indexArray:", indexArray);
      console.log("From property at index:", index);
      console.log("Current full_nameScale:", newFormData.full_nameScale);
      console.log("Current mailScale:", newFormData.mailScale);

      if (
        newFormData.full_nameScale.hasOwnProperty(index) &&
        Array.isArray(newFormData.full_nameScale[index])
      ) {
        newFormData.full_nameScale[index] = restructureArray(
          newFormData.full_nameScale[index]
        );
        console.log("Updated full_nameScale:", newFormData.full_nameScale);
      }

      if (
        newFormData.mailScale.hasOwnProperty(index) &&
        Array.isArray(newFormData.mailScale[index])
      ) {
        newFormData.mailScale[index] = restructureArray(
          newFormData.mailScale[index]
        );
        console.log("Updated mailScale:", newFormData.mailScale);
      }

      return newFormData;
    });

    setContact((prev) => (prev > 0 ? prev - 1 : 0));
  };

  // useEffect(() => {
  //   console.log("================formData====================");
  //   console.log(formData);
  //   console.log("====================================");
  // }, [formData]);

  return (
    <>
      <div>
        {loading ? (
          <div>Cargando Datos...</div>
        ) : (
          <div className="card-body">
            <div className="row">
              <div className="col-sm-12">
                <form
                  className="form-horizontal fv-form fv-form-bootstrap"
                  acceptCharset="UTF-8"
                  id="formValidation"
                  encType="multipart/form-data"
                  noValidate="novalidate"
                  onSubmit={handleSubmit(handleFormSubmit)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="rootwizard">
                    <br />
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id="tab1">
                        {/* Nombre */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label"
                            htmlFor="name"
                          >
                            Nombre <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <input
                              id="name"
                              className={`form-control ${
                                errors.name?.type === "required"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.name?.type === "pattern"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.name?.type === "validate"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.name?.type === "maxLength"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.name?.type === "minLength"
                                  ? "missing-field"
                                  : ""
                              }`}
                              placeholder="Nombre"
                              name="name"
                              type="text"
                              data-fv-field="name"
                              defaultValue={sla.sla.name}
                              {...register("name", {
                                required: "El campo es requerido",
                                pattern: {
                                  value: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                                  message: "Ingresa un Nombre valido",
                                },
                                maxLength: 255,
                                minLength: 3,
                              })}
                              onChange={handleFormData}
                            />
                            {errors.name?.type === "required" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="name"
                                data-fv-result="INVALID"
                              >
                                {errors.name.message}
                              </small>
                            )}
                            {errors.name?.type === "pattern" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="name"
                                data-fv-result="INVALID"
                              >
                                {errors.name.message}
                              </small>
                            )}

                            {errors.name?.type === "minLength" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="name"
                                data-fv-result="INVALID"
                              >
                                Por favor introduce un valor con una longitud
                                entre 3 y 255 caracteres
                              </small>
                            )}
                            {errors.name?.type === "maxLength" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="name"
                                data-fv-result="INVALID"
                              >
                                Por favor introduce un valor con una longitud
                                entre 3 y 255 caracteres
                              </small>
                            )}
                          </div>
                        </div>

                        {/* Descripción */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label"
                            htmlFor="description"
                          >
                            Descripción{" "}
                            <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <textarea
                              id="description"
                              className={`form-control ${
                                errors.description?.type === "required"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.description?.type === "pattern"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.description?.type === "validate"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.description?.type === "maxLength"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.description?.type === "minLength"
                                  ? "missing-field"
                                  : ""
                              }`}
                              placeholder="Descripción"
                              name="description"
                              data-fv-field="description"
                              defaultValue={sla.sla.description}
                              rows={4}
                              cols={50}
                              {...register("description", {
                                required: "El campo es requerido",
                                maxLength: 255,
                                minLength: 3,
                              })}
                              onChange={handleFormData}
                            />

                            {errors.description?.type === "required" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="description"
                                data-fv-result="INVALID"
                              >
                                {errors.description.message}
                              </small>
                            )}
                            {errors.description?.type === "pattern" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="description"
                                data-fv-result="INVALID"
                              >
                                {errors.description.message}
                              </small>
                            )}

                            {errors.description?.type === "minLength" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="description"
                                data-fv-result="INVALID"
                              >
                                Por favor introduce un valor con una longitud
                                entre 3 y 255 caracteres
                              </small>
                            )}
                            {errors.description?.type === "maxLength" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="description"
                                data-fv-result="INVALID"
                              >
                                Por favor introduce un valor con una longitud
                                entre 3 y 255 caracteres
                              </small>
                            )}
                          </div>
                        </div>

                        {/* Servicio */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label"
                            htmlFor="notification_service_id"
                          >
                            Servicio <span style={{ color: "#fa0073" }}>*</span>
                          </label>
                          <div v className="col-sm-10">
                            <select
                              id="notification_service_id"
                              className={`form-control ${
                                errors.notification_service_id?.type ===
                                "required"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.notification_service_id?.type ===
                                "pattern"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.notification_service_id?.type ===
                                "validate"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.notification_service_id?.type ===
                                "maxLength"
                                  ? "missing-field"
                                  : ""
                              } ${
                                errors.notification_service_id?.type ===
                                "minLength"
                                  ? "missing-field"
                                  : ""
                              }`}
                              placeholder="Servicio"
                              name="notification_service_id"
                              data-fv-field="notification_service_id"
                              {...register("notification_service_id", {
                                required: "El campo es requerido",
                                pattern: /^(?!selected$).*$/,
                              })}
                              onChange={handleFormData}
                            >
                              <option value="selected">Servicio</option>
                              {services.map((service) => (
                                <option
                                  key={service.id}
                                  defaultValue={sla.sla.notification_service_id}
                                  selected={
                                    sla.sla.notification_service_id ===
                                    service.id
                                  }
                                >
                                  {service.name}
                                </option>
                              ))}
                            </select>
                            {errors.notification_service_id?.type ===
                              "required" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="notification_service_id"
                                data-fv-result="INVALID"
                              >
                                {errors.notification_service_id.message}
                              </small>
                            )}
                            {errors.notification_service_id?.type ===
                              "pattern" && (
                              <small
                                className="help-block"
                                data-fv-validator="notEmpty"
                                data-fv-for="notification_service_id"
                                data-fv-result="INVALID"
                              >
                                Por favor selecciona una opción
                              </small>
                            )}
                          </div>
                        </div>

                        {/* Niveles de escalamiento */}
                        <div className="form-group row mb-3 ">
                          <label
                            className="col-sm-2 control-label"
                            htmlFor="range_scale"
                          >
                            Niveles de escalamiento
                          </label>

                          <div className="col-sm-10 table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>
                                    <TooltipComponet
                                      text="Intervalo en minutos para notificar a cada contacto de este nivel."
                                      position="top"
                                    />
                                    Rango (minuto)
                                  </th>
                                  <th>
                                    <TooltipComponet
                                      text="Se realizarán verificaciones del servicio cada 5 minutos.
La cantidad de intentos establecida determinará cuántas veces se probará antes de escalar al siguiente nivel."
                                      position="top"
                                    />
                                    Intentos
                                  </th>
                                  <th>Contactos</th>
                                  <th></th>
                                </tr>
                              </thead>

                              <tbody className="contactContainerScale">
                                <tr>
                                  {/* Rango */}
                                  <td>
                                    <div className="form-group row">
                                      <div className="col-sm-12">
                                        <input
                                          type="number"
                                          className="form-control range_scale"
                                          placeholder="Rango pruebas"
                                          id="range_scale"
                                          name="range_scale"
                                          defaultValue={
                                            formData.range_scale[0] || ""
                                          }
                                          min="1"
                                          onChange={(e) =>
                                            handleRangeScale(0, e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  {/* Intentos */}
                                  <td>
                                    <div className="form-group row">
                                      <div className="col-sm-12">
                                        <input
                                          type="number"
                                          className="form-control tries"
                                          placeholder="Intentos"
                                          id="tries"
                                          name="tries"
                                          defaultValue={formData.tries[0] || ""}
                                          min="1"
                                          onChange={(e) =>
                                            handleTries(0, e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </td>

                                  {/* Contactos */}
                                  <td
                                    colspan="2"
                                    className="pr-0 m-0 text-center"
                                  >
                                    <table className="table table-borderless">
                                      <thead>
                                        <tr>
                                          <th
                                            className="text-center align-middle p-1"
                                            style={{
                                              width: "50%",
                                              height: "50%",
                                              maxWidth: "50%",
                                              minWidth: "50%",
                                            }}
                                          >
                                            Nombre
                                          </th>
                                          <th
                                            className="text-center align-middle p-1"
                                            style={{
                                              width: "50%",
                                              height: "50%",
                                              maxWidth: "50%",
                                              minWidth: "50%",
                                            }}
                                          >
                                            Correo
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="contactsScale">
                                        <tr>
                                          <td>
                                            {/* nombre completo */}
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="full_nameScale"
                                                name="full_nameScale"
                                                value={
                                                  formData.full_nameScale[0]
                                                    ? formData
                                                        .full_nameScale[0][0]
                                                    : ""
                                                }
                                                placeholder="Nombre completo"
                                                {...register("full_nameScale", {
                                                  pattern: {
                                                    value:
                                                      /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                                                    message:
                                                      "Ingresa un Nombre valido",
                                                  },
                                                  maxLength: 255,
                                                  minLength: 3,
                                                })}
                                                onChange={(e) =>
                                                  handleFullNameScaleChange(
                                                    0,
                                                    0,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                              {errors.full_nameScale?.type ===
                                                "pattern" && (
                                                <small
                                                  className="help-block"
                                                  data-fv-validator="notEmpty"
                                                  data-fv-for="full_nameScale"
                                                  data-fv-result="INVALID"
                                                >
                                                  {
                                                    errors.full_nameScale
                                                      .message
                                                  }
                                                </small>
                                              )}

                                              {errors.full_nameScale?.type ===
                                                "minLength" && (
                                                <small
                                                  className="help-block"
                                                  data-fv-validator="notEmpty"
                                                  data-fv-for="full_nameScale"
                                                  data-fv-result="INVALID"
                                                >
                                                  Por favor introduce un valor
                                                  con una longitud entre 3 y 255
                                                  caracteres
                                                </small>
                                              )}
                                              {errors.full_nameScale?.type ===
                                                "maxLength" && (
                                                <small
                                                  className="help-block"
                                                  data-fv-validator="notEmpty"
                                                  data-fv-for="full_nameScale"
                                                  data-fv-result="INVALID"
                                                >
                                                  Por favor introduce un valor
                                                  con una longitud entre 3 y 255
                                                  caracteres
                                                </small>
                                              )}
                                            </div>
                                          </td>
                                          <td>
                                            {/* Correo */}
                                            <div className="form-group">
                                              <input
                                                type="text"
                                                className="form-control"
                                                id="mailScale"
                                                name="mailScale"
                                                value={
                                                  formData.mailScale[0]
                                                    ? formData.mailScale[0][0]
                                                    : ""
                                                }
                                                placeholder="Correo"
                                                {...register("mailScale", {
                                                  pattern: {
                                                    value:
                                                      /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                                                    message:
                                                      "Por favor introduce un correo electrónico válido",
                                                  },
                                                })}
                                                onChange={(e) =>
                                                  handleMailScale(
                                                    0,
                                                    0,
                                                    e.target.value
                                                  )
                                                }
                                              />
                                              {errors.mailScale?.type ===
                                                "pattern" && (
                                                <small
                                                  className="help-block"
                                                  data-fv-validator="notEmpty"
                                                  data-fv-for="mailScale"
                                                  data-fv-result="INVALID"
                                                >
                                                  {errors.mailScale.message}
                                                </small>
                                              )}

                                              {errors.mailScale?.type ===
                                                "minLength" && (
                                                <small
                                                  className="help-block"
                                                  data-fv-validator="notEmpty"
                                                  data-fv-for="mailScale"
                                                  data-fv-result="INVALID"
                                                >
                                                  Por favor introduce un valor
                                                  con una longitud entre 3 y 255
                                                  caracteres
                                                </small>
                                              )}
                                              {errors.mailScale?.type ===
                                                "maxLength" && (
                                                <small
                                                  className="help-block"
                                                  data-fv-validator="notEmpty"
                                                  data-fv-for="mailScale"
                                                  data-fv-result="INVALID"
                                                >
                                                  Por favor introduce un valor
                                                  con una longitud entre 3 y 255
                                                  caracteres
                                                </small>
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                        {Array.from({ length: contact }).map(
                                          (_, index) => (
                                            <>
                                              <Contacto
                                                key={index}
                                                index={0}
                                                indexArray={index}
                                                remover={removeContact}
                                                handleFullNameScaleChange={
                                                  handleFullNameScaleChange
                                                }
                                                handleMailScale={
                                                  handleMailScale
                                                }
                                                data={sla}
                                                formData={formData}
                                              />
                                            </>
                                          )
                                        )}
                                      </tbody>
                                      <tbody>
                                        <tr>
                                          <td colSpan={3}>
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              <button
                                                style={{
                                                  backgroundColor: "#28a745",
                                                  color: "white",
                                                  borderRadius: "50%",
                                                  width: "40px",
                                                  height: "40px",
                                                  border: "none",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "center",
                                                  cursor: "pointer",
                                                  marginRight: "10px",
                                                }}
                                                type="button"
                                                id="agregar2"
                                                onClick={addContact}
                                              >
                                                <BiPlusMedical />
                                              </button>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>

                                  <td> </td>
                                </tr>

                                {Array.from({ length: esca }).map(
                                  (_, index) => (
                                    <>
                                      <Escalamiento
                                        remover={removeMed}
                                        setFormData={setFormData}
                                        handleRangeScale={handleRangeScale}
                                        handleTries={handleTries}
                                        key={index}
                                        index={index}
                                        handleFullNameScaleChange={
                                          handleFullNameScaleChange
                                        }
                                        data={sla}
                                        formData={formData}
                                        handleMailScale={handleMailScale}
                                      />
                                    </>
                                  )
                                )}
                              </tbody>

                              <tbody>
                                <tr>
                                  <td colSpan={4}>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      <button
                                        style={{
                                          backgroundColor: "#28a745",
                                          color: "white",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          border: "none",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor: "pointer",
                                        }}
                                        type="button"
                                        onClick={addMed}
                                      >
                                        <BiPlusMedical />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <nav>
                        <ul className="pagination pager wizard">
                          <li
                            className="page-item next ms-auto disabled hidden"
                            style={{ display: "none" }}
                          >
                            <a href="#" className="page-link">
                              Siguiente
                            </a>
                          </li>
                          <li className="page-item next finish ms-auto">
                            <button type="submit" className="page-link">
                              Actualizar
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EditSlas;
